import { createBrowserRouter } from 'react-router-dom';
import App from '../App';
import Home from '../components/Home';
import ViewMore from '../pages/ViewMore';
import OrphanageSupport from '../pages/OrphanageSupport';
import CampDetails from '../pages/CampDetails';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Home /> },
      { path: 'viewmore', element: <ViewMore /> },
      { path: 'OrphanageSupport', element: <OrphanageSupport /> },
      { path: 'camp-details', element: <CampDetails /> },
    ],
  },
]);

export default router;
